import { api } from "./api";

export const mentalHealthApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientScores: builder.query<{ gad7: number; phq9: number }, number>({
      query: (patientId) => ({
        method: "GET",
        url: `/api/patients/${patientId}/mental-health-scores`,
      }),
    }),
  }),
});

export const { useGetPatientScoresQuery } = mentalHealthApi;
